module.exports = __webpack_public_path__ + "media/images/svg/x-756eaf86fc02f47c96f3e380ddf3f04e.svg";